import { render, staticRenderFns } from "./SectionBar.vue?vue&type=template&id=45c0539e&scoped=true&"
import script from "./SectionBar.vue?vue&type=script&lang=js&"
export * from "./SectionBar.vue?vue&type=script&lang=js&"
import style0 from "./SectionBar.vue?vue&type=style&index=0&id=45c0539e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0539e",
  null
  
)

export default component.exports